/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.0
 */

import filter from 'lodash/filter';
import get from 'lodash/get';
import keys from 'lodash/keys';
import mapValues from 'lodash/mapValues';
import slice from 'lodash/slice';
import { SagaIterator } from 'redux-saga';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';

import { requestSaga } from '../../sagas/requestSaga';
import { API_HOSTNAME, SUPER_SEARCH } from '../app/Api';
import { superSearchEmpty, superSearchFailed, superSearchSuccessful } from './superSearchActions';
import { SUPER_SEARCH_START } from './superSearchConstants';
import { initialSearchResponse } from './superSearchReducer';
import { makeSelectSuperSearchValue } from './superSearchSelectors';
import { ISuperSearch } from './superSearchTypes';

export function makeThinSearchResponse(searchReponse: any): ISuperSearch {
    const result = get(searchReponse, 'data', initialSearchResponse);
    const itemsCount = get(searchReponse, 'data.itemsCount', 5);
    const maxItemsCount = get(searchReponse, 'data.maxItemsCount', 10);
    delete result.itemsCount;
    delete result.maxItemsCount;
    const groups = filter(keys(result), group => result[group].length);

    let limit = itemsCount;
    if (groups.length === 1) {
        limit = maxItemsCount;
    }

    // @ts-ignore
    return mapValues(result, group => slice(group, 0, limit));
}

export function* getSuperSearchResponseSaga(): SagaIterator {
    try {
        const searchValue = yield select(makeSelectSuperSearchValue());
        const finalValue = yield call(() => searchValue.trim());
        if (finalValue.length > 1) {
            const url = API_HOSTNAME + SUPER_SEARCH + '?query=' + encodeURIComponent(finalValue);
            const searchReponse = yield call(requestSaga, url, 'GET', null, {
                abortControllerId: SUPER_SEARCH,
            });
            const response = makeThinSearchResponse(searchReponse);

            if (!response.accounts.length
                && !response.mobileLabels.length
                && !response.mobiles.length
            ) {
                yield put(superSearchEmpty());
            } else {
                yield put(superSearchSuccessful(response));
            }
        }
    } catch (error: any) {
        if (error.name !== 'AbortError') {
            yield put(superSearchFailed(error));
        }
    }
}

export function* initSuperSearchSaga(): SagaIterator {
    yield all([
        takeEvery(SUPER_SEARCH_START, getSuperSearchResponseSaga),
    ]);
}
